import { MouseEvent, useCallback, useState } from "react";

interface AboutUs {
    isMethodologyActive: boolean;
}
interface Toggles {
    isShareBtnClicked: boolean;
    isCountrySelected: boolean;
}

interface ShowSubRegionsCountriesProp {
    showSubRegionsCountries: boolean;
}

type CombinedProps = AboutUs & Toggles & ShowSubRegionsCountriesProp;

const useToggle = () => {
    const [toggleState, setToggleState] = useState<CombinedProps>({
        isMethodologyActive: false,
        isShareBtnClicked: false,
        isCountrySelected: false,
        showSubRegionsCountries: false
    });

    const handleToggleState = useCallback(
        (toggleType: string, e?: MouseEvent) => {
            if (e) e.stopPropagation();
            setToggleState((prevState) => {
                const key = toggleType as string as keyof typeof toggleState;
                return { ...toggleState, [toggleType]: !prevState[key] };
            });
        },
        [toggleState, setToggleState]
    );

    return { handleToggleState, toggleState };
};

export default useToggle;
